
import Circles from "./Circles";
import { useState } from "react"
import Thankyou from "./Thankyou"


const Rating = () => {
	const [Submit, setSubmit] = useState(false)
	const [rating, setrating] = useState(null)
	return (
		<div className="rating">
			{Submit && <Thankyou rating={rating} />}
			{!Submit && (
				<div>
					<Circles image={true} />
					<h1>How did we do ?</h1>

					<p>
						Please let us know how we did with your support request.All feedback
						is appreciated to help us improve our offering!
					</p>
					<Circles number={1} circlefor="num" setrating={setrating} />
					<Circles number={2} circlefor="num" setrating={setrating} />
					<Circles number={3} circlefor="num" setrating={setrating} />
					<Circles number={4} circlefor="num" setrating={setrating} />
					<Circles number={5} circlefor="num" setrating={setrating} />
					<button className="submit-button" onClick={() => setSubmit(true)}> SUBMIT</button>
				</div>
			)}
		</div>
	);
}
 
export default Rating;